import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import CtaTextBanner from '../Common/CtaTextBanner';
import ImageCoverComponent from '../Common/ImageCoverComponent';
import {
  calculatePaddingTop,
  fireClickedCategoryCardEvent,
  getDesktopImage,
  getMobileImage,
} from '../utils';
import { GeneralSectionCover, MutliImageGridCover } from './styled';
import { queryParamHandling } from '../../../Utils/productPageUtils';

function MultiCategorySection(props) {
  const { data, categoryId } = props;
  const gridSize = data?.gridSize;
  const backgroundImage = data?.sectionBgImage;
  const backgroundImageD = data?.sectionBgImageDesktop;
  const ctaText = data?.ctaText;
  const asRatioObject = { 4: '41:23', 2: '41:68' };
  const count = data?.items?.length;

  const [cardEffect, setCardEffect] = useState({ index: -1 });
  const router = useRouter();
  const callbackFunction = (index, deeplinkValue, element) => {
    setCardEffect({ index: index, effect: 'lowOpacity' });
    setTimeout(() => {
      const { addParams, newUrl } = queryParamHandling(deeplinkValue);
      router.push(`${newUrl}` + addParams, '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
    fireClickedCategoryCardEvent({
      id: categoryId,
      card_name: element?.itemName,
      card_id: element?._id,
      section_id: data?._id,
      section_name: data?.itemName,
      deeplink_value: deeplinkValue,
    });
  };
  const { heading, subHeading } = data;
  const imageRatioMobile = calculatePaddingTop(data?.mobileImageRatio);
  const imageRatioDesktop = calculatePaddingTop(data?.desktopImageRatio);
  const sectionBgMRatio = calculatePaddingTop(data?.sectionBgMobileImageRatio);
  const sectionBgDRatio = calculatePaddingTop(data?.sectionBgDesktopImageRatio);

  return (
    <GeneralSectionCover>
      {backgroundImage && (
        <ImageCoverComponent
          imageRatioMobile={sectionBgMRatio}
          imageRatioDesktop={sectionBgDRatio}
          mobileImage={backgroundImage}
          desktopImage={backgroundImageD}
        />
      )}
      {/* {heading && <SubHeadingStyle>{heading}</SubHeadingStyle>}
            {subHeading && (
                <SubHeadingDescriptionStyle>
                    {subHeading}
                </SubHeadingDescriptionStyle>
            )} */}

      <MutliImageGridCover gridSize={gridSize}>
        {data?.items?.map((element, index) => {
          const desktopImage = getDesktopImage(element);
          const mobileImage = getMobileImage(element);
          return element.image ? (
            <AnchorCoverTag
              url={element?.webUrl}
              key={`category${index}`}
              cardEffect={cardEffect.index === index ? 'lowOpacity' : ''}
              callbackFunction={callbackFunction}
              index={index}
              element={element}
            >
              {' '}
              <ImageCoverComponent
                imageRatioMobile={imageRatioMobile}
                imageRatioDesktop={imageRatioDesktop}
                mobileImage={mobileImage}
                desktopImage={desktopImage}
              />
            </AnchorCoverTag>
          ) : null;
        })}
      </MutliImageGridCover>
      {ctaText && <CtaTextBanner ctaText={ctaText} />}
    </GeneralSectionCover>
  );
}

export default MultiCategorySection;
